import { List, Record } from 'immutable';
import { THREAD_REMOVAL_TYPE } from './threadRemovalKeyPaths';
import { UNKNOWN } from './threadRemovalTypes';
const UnknownRemoval = Record({
  [THREAD_REMOVAL_TYPE]: UNKNOWN,
  audit: null,
  members: List()
}, 'UnknownRemoval');
export default UnknownRemoval;